// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require ./_namespace

//= require flux/dispatcher
//= require flux/store
//= require_tree .
// MAGIC_DESPROCKET_START
require('sprocket-compat?this!javascripts/flux/_namespace.coffee')
require('sprocket-compat?this!javascripts/flux/dispatcher.coffee')
require('sprocket-compat?this!javascripts/flux/store.coffee')
// MAGIC_DESPROCKET_END
